export const myConfig = {
	recaptchaSitekey: '6Lc-Lc0ZAAAAABsRe3dU3o-T7eoDYySTYs5fhEOe',
	apiUrl: 'https://qzg6fnsxlf.execute-api.ap-southeast-2.amazonaws.com/prod',
    cognito: {
        userPoolId: 'ap-southeast-2_lssTq2mcZ',
        userPoolClientId: '5vs3pi765qc4m9e9vf5tjafl8t',
        region: 'ap-southeast-2'
    }
};